import { useQuery } from "@apollo/client";
import { useMediaQuery } from "react-responsive";

import { Box } from "@/components/layout/flexbox";
import { isXsQuery } from "@/components/layout/Media";
import Clickable from "@/components/pieces/interaction/Clickable";
import StyledTag from "@/components/pieces/StyledTag";
import { PopularTitlesDocument } from "@/graphql";

export default function PopularTitles({ excludingTitles, onSelect }) {
  const isXs = useMediaQuery(isXsQuery);
  const { data } = useQuery(PopularTitlesDocument);

  const popularTitles = (data ? data.popularTitles : []).filter(
    (pt) =>
      !excludingTitles.find((jt) => jt.normalizedTitle === pt.normalizedTitle),
  );

  return (
    <>
      {popularTitles.length ? (
        <Box mt={4}>
          <Box mb={2}>Popular Titles</Box>
          {popularTitles.map((pt) => {
            return (
              <Clickable key={pt.normalizedTitle} onClick={() => onSelect(pt)}>
                <StyledTag large={!isXs}>{pt.title}</StyledTag>
              </Clickable>
            );
          })}
        </Box>
      ) : null}
    </>
  );
}
